import React from 'react';
import { Cpu, Cloud, LayoutDashboard, Smartphone } from 'lucide-react';

const nodes = [
  { id: 'device', label: 'Smart Device', Icon: Cpu },
  { id: 'cloud', label: 'Cloud', Icon: Cloud },
  { id: 'dashboard', label: 'Dashboard', Icon: LayoutDashboard },
  { id: 'mobile', label: 'Mobile App', Icon: Smartphone },
] as const;

export const PlatformHeroVisual: React.FC = () => (
  <div className="platform-hero-visual" aria-hidden>
    <div className="platform-hero-visual__track">
      <div className="platform-hero-visual__connector" aria-hidden />
      <div className="platform-hero-visual__nodes">
        {nodes.map(({ id, label, Icon }) => (
          <div key={id} className={`platform-hero-visual__node platform-hero-visual__node--${id}`}>
            <div className="platform-hero-visual__node-icon">
              <Icon className="platform-hero-visual__node-svg" strokeWidth={1.75} aria-hidden />
            </div>
            <span className="platform-hero-visual__node-label">{label}</span>
          </div>
        ))}
      </div>
    </div>
    <div className="platform-hero-visual__widgets">
      <div className="platform-hero-visual__widget platform-hero-visual__widget--chart">
        <span className="platform-hero-visual__widget-title">Active devices</span>
        <div className="platform-hero-visual__bars" aria-hidden>
          <span style={{ height: '45%' }} />
          <span style={{ height: '72%' }} />
          <span style={{ height: '58%' }} />
          <span style={{ height: '88%' }} />
          <span style={{ height: '64%' }} />
        </div>
        <span className="platform-hero-visual__widget-value">12.4k online</span>
      </div>
      <div className="platform-hero-visual__widget platform-hero-visual__widget--status">
        <span className="platform-hero-visual__widget-dot" />
        <span className="platform-hero-visual__widget-title">Fleet health</span>
        <span className="platform-hero-visual__widget-value">99.2%</span>
      </div>
    </div>
  </div>
);
